import { render, staticRenderFns } from "./IncomingCard.vue?vue&type=template&id=124c1267&scoped=true"
import script from "./IncomingCard.vue?vue&type=script&lang=js"
export * from "./IncomingCard.vue?vue&type=script&lang=js"
import style0 from "./IncomingCard.vue?vue&type=style&index=0&id=124c1267&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124c1267",
  null
  
)

export default component.exports